import styled, { css } from "styled-components"

import { minWidth, when } from "utils"

export const Wrapper = styled.div`
  width: calc(100% - 5.4rem);
  margin: 0 2.7rem 2rem;
  display: flex;
  align-items: flex-start;

  ${minWidth.tablet`
    max-width: 58rem;
    margin: 0 auto 2rem;
  `}

  ${minWidth.hamburgerLarge`
    max-width: 72.5rem;
  `}
`

const heading1 = css`
  font-size: 2.8rem;
  font-weight: 400;
  line-height: 1.35;

  ${minWidth.tablet`
    font-size: 2.6rem;
  `}

  ${minWidth.hamburgerLarge`
    font-size: 3rem;
  `}
`

const heading2 = css`
  font-size: 2.2rem;
  font-weight: 400;
  line-height: 1.1;

  ${minWidth.hamburgerLarge`
    font-size: 3rem;
    line-height: 1.35;
  `}
`

const heading3 = css`
  font-size: 2rem;
  font-weight: 400;
  line-height: 1.62;

  ${minWidth.hamburgerLarge`
    font-size: 2.2rem;
  `}
`

export const Number = styled.span`
  padding-right: 1rem;
  display: block;
  font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  ${({ level }) => (level === 1 ? heading1 : level === 2 ? heading2 : heading3)}
  color: #222222;
`

export const Heading1 = styled.h1`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  ${heading1}

  ${when("numbered")`
    font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  `}
`

export const Heading2 = styled.h2`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  ${heading2}

  ${when("numbered")`
    font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  `}
`

export const Heading3 = styled.h3`
  font-family: Maax, "Helvetica Neue", Helvetica, Arial, sans-serif;
  ${heading3}

  ${when("numbered")`
    font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  `}
`
